"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = clearSuggestedActionsOnPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _postActivity = require("../actions/postActivity");

var _setSuggestedActions = _interopRequireDefault(require("../actions/setSuggestedActions"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(clearSuggestedActions),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(clearSuggestedActionsOnPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(clearSuggestedActionsOnPostActivitySaga);

function clearSuggestedActions() {
  return _regenerator["default"].wrap(function clearSuggestedActions$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _setSuggestedActions["default"])());

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function clearSuggestedActionsOnPostActivity() {
  return _regenerator["default"].wrap(function clearSuggestedActionsOnPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(function (_ref) {
            var payload = _ref.payload,
                type = _ref.type;
            return type === _postActivity.POST_ACTIVITY_PENDING && payload.activity.type === 'message';
          }, clearSuggestedActions);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function clearSuggestedActionsOnPostActivitySaga() {
  return _regenerator["default"].wrap(function clearSuggestedActionsOnPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(clearSuggestedActionsOnPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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